import React from 'react';

import {
    Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
} from '@material-ui/core';

import { CircularProgress } from '@material-ui/core';
import { CustomToast, } from '@jumbo/components/custom/Toast';
import GridContainer from '@jumbo/components/GridContainer';
import { TEXT_COLOR_FT } from 'config/config';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));


const DeleteConfirmationModal = props => {

    const {
        openDialog = false,
        close,
        postData,
        deleteData,
        loading,
    } = props;


    const classes = addStyle()
    const onCloseDialog = event => {
        close();
    };

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{color:TEXT_COLOR_FT}}>
                    <Grid item >
                        {'Eliminar  ' + deleteData.header}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
                    <GridContainer>
                        Está seguro que desea eliminar el registro de {deleteData.nombre}

                    </GridContainer>
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
                        {"Cerrar"}
                    </Button>
                    <Box ml={2}>
                        {<Button variant="outlined" color="primary" onClick={() => { postData(deleteData.id) }} >
                            {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Eliminar'}
                        </Button>
                        }

                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
